

import ProductCustomizer from '@/components/customizer/Product'

export default {
  name: 'ProductPage', // Product page
  components: {
    ProductCustomizer
  }
}
